<div class="content">
  <div class="container-fluid">
    <div class="page-title">
      <h1>Device Detail</h1>
      <small class="float-right">
        <a routerLink="/info" class="back">
          <i class="fa fa-arrow-left" aria-hidden="true"></i>
          Back</a>
      </small>
    </div>
    <div class="index-content device-detail">
      <div class="header-title"><h5>{{changeInfoName}}</h5></div>
      <div class="content-info evnets" style="margin: 0px;">
        <ul class="info">
          <li><span>Storage Level</span>{{changeInfoNewLevel}}</li>
          <li><span>Connected Date</span>{{changeInfoCreateTime | date: 'yyyy/MM/dd'}}</li>
          <li><span>Expired Date</span>{{changeInfoNewExpiredDate | date: 'yyyy/MM/dd'}}</li>
        </ul>
          <!-- <div class="row">
              <div class="col-md-4">{{changeInfoNewLevel}}</div>
              <div class="col-md-4">{{changeInfoCreateTime}}</div>
              <div class="col-md-4"> {{changeInfoNewExpiredDate}}</div>
          </div> -->
      </div>
      <div class="content-info evnets">
        <div class="content-title-table">
          <h5>History</h5>
        </div>
        <p-dataTable #dt [rows]="10" [value]="changeHistory" [paginator]="true" [rowsPerPageOptions]="[10,20]">
          <p-column [sortable]="true" field="CreateTime" header="Change Date" [style]="{'width':'150px'}"
            styleClass="col-nowrap">
            <ng-template let-col let-data="rowData" pTemplate="body">
              {{(data.CreateTime != null) ? ((data.CreateTime * 1000) | date: 'yyyy/MM/dd') : ''}}
            </ng-template>
          </p-column>
          <p-column [sortable]="true" field="Type" header="Type" [style]="{'width':'150px'}"
            styleClass="col-nowrap">
            <ng-template let-col let-data="rowData" pTemplate="body">
              {{data.Type}}
            </ng-template>
          </p-column>
          <p-column [sortable]="true" field="PreviousLevel" header="Previous Level" [style]="{'width':'150px'}"
            styleClass="col-nowrap">
            <ng-template let-col let-data="rowData" pTemplate="body">
              {{(data.PreviousLevel != null) ? ('Level ' + data.PreviousLevel) : '--'}}
            </ng-template>
          </p-column>
          <p-column [sortable]="true" field="NewLevel" header="New Level" [style]="{'width':'150px'}"
            styleClass="col-nowrap">
            <ng-template let-col let-data="rowData" pTemplate="body">
              {{(data.NewLevel != null) ? ('Level ' + data.NewLevel) : '--'}}
            </ng-template>
          </p-column>
          <p-column [sortable]="true" field="PeriodExtend" header="Period Extend" [style]="{'width':'150px'}"
            styleClass="col-nowrap">
            <ng-template let-col let-data="rowData" pTemplate="body">
              {{(data.PeriodExtend != null) ? (data.PeriodExtend | numToDate) : '--'}}
            </ng-template>
          </p-column>
          <p-column [sortable]="true" field="PreviousExpiredDate" header="Previous Expired Date"
            [style]="{'width':'190px'}" styleClass="col-nowrap">
            <ng-template let-col let-data="rowData" pTemplate="body">
              {{(data.PreviousExpiredDate != null) ? ((data.PreviousExpiredDate * 1000) | date: 'yyyy/MM/dd') : ''}}
            </ng-template>
          </p-column>
          <p-column [sortable]="true" field="NewExpiredDate" header="New Expired Date" [style]="{'width':'170px'}"
            styleClass="col-nowrap">
            <ng-template let-col let-data="rowData" pTemplate="body">
              {{(data.NewExpiredDate != null) ? ((data.NewExpiredDate * 1000) | date: 'yyyy/MM/dd') : ''}}
            </ng-template>
          </p-column>
          <p-column [sortable]="true" field="AmountPaid" header="Amount Paid" [style]="{'width':'170px'}"
            styleClass="col-nowrap">
            <ng-template let-col let-data="rowData" pTemplate="body">
              {{(data.AmountPaid != null) ? (data.AmountPaid) : '--'}}
            </ng-template>
          </p-column>
          <ng-template pTemplate="emptymessage">
            No Data found
          </ng-template>
        </p-dataTable>
      </div>
      <div class="content-info evnets">
        <div class="content-title-table">
          <h5>License List</h5>
        </div>
        <p-table #dt class="deviceTable" [columns]="deviceTable_cols" [value]="licenseData" [rows]="10" [paginator]="true"
        [rowsPerPageOptions]="[10,20]" (sortFunction)="customSort($event)" [customSort]="true" [scrollable]="true">
        <ng-template pTemplate="header" let-columns>
            <tr>
              <ng-template ngFor let-col [ngForOf]="columns" let-i="index">
                <th [pSortableColumn]="col.field" [ngStyle]="{'width.px':(col.width) }">
                  {{col.header}}
                  <p-sortIcon [field]="col.field"></p-sortIcon>
                </th>
                <!-- <th *ngIf="i==7" [ngStyle]="{'width.px':(col.width)}">
                  {{col.header}}
                </th> -->
              </ng-template>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
          <tr>
            <!-- <td style="width: 80px" class="col-nowrap">
              <span>{{rowIndex+1}}</span>
            </td> -->
            <td style="width: 150px" class="col-nowrap">{{rowData.AddDate}}</td>
            <td style="width: 150px" class="col-nowrap">{{rowData.License}}</td>
            <td style="width: 100px" class="col-nowrap">{{rowData.Level}}</td>
            <td style="width: 100px" class="col-nowrap">{{rowData.Period}}</td>
            <td style="width: 180px" class="col-nowrap">{{rowData.StartedDate}}</td>
          </tr>
        </ng-template>
      </p-table>
      </div>
    </div>
  </div>
</div>
